import { customDateFormatWithTime, textFormatter } from "components/Common/formatter";
import ButtonGroup from "components/Common/buttons/ButtonGroup";
import openLock from "assets/images/svg/Open Lock.svg";
import { USER_ROLES } from "utils/constants";

export const quarantineMetersListColumns = handleRemove => [
  {
    title: "Barcode",
    dataIndex: "barcode",
    render: textFormatter,
  },
  {
    title: "Serial Number",
    dataIndex: "serial",
    render: textFormatter,
  },
  {
    title: "Depot",
    dataIndex: "depot",
    render: textFormatter,
  },
  {
    title: "Created At",
    dataIndex: "createdAt",
    render: cellContent => textFormatter(cellContent && customDateFormatWithTime(cellContent)),
  },
  {
    title: "Quarantined At",
    dataIndex: "quarantinedAt",
    render: cellContent => textFormatter(cellContent && customDateFormatWithTime(cellContent)),
  },
  {
    dataIndex: "",
    title: "",
    width: "4%",
    render: row => (
      <ButtonGroup
        roles={[USER_ROLES.PRODUCT_TECHNICIAN_LEAD]}
        tooltipTitle="Remove from quarantine"
        icon={openLock}
        handleClick={() => handleRemove([row.id])}
      />
    ),
  },
];
